import { render, staticRenderFns } from "./GoalsReport.vue?vue&type=template&id=ca995190&scoped=true"
import script from "./GoalsReport.vue?vue&type=script&lang=js"
export * from "./GoalsReport.vue?vue&type=script&lang=js"
import style0 from "./GoalsReport.vue?vue&type=style&index=0&id=ca995190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca995190",
  null
  
)

export default component.exports